import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "d-flex mb-4",
  style: {"align-items":"center"}
}
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { style: {"width":"180px"} }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["colspan"]
const _hoisted_6 = { class: "expand-cell" }
const _hoisted_7 = { class: "invoice-detail-table" }
const _hoisted_8 = { class: "invoice-detail-table__row" }
const _hoisted_9 = { class: "invoice-detail-table__value" }
const _hoisted_10 = { class: "invoice-detail-table__row" }
const _hoisted_11 = { class: "invoice-detail-table__value" }
const _hoisted_12 = { class: "invoice-detail-table__row" }
const _hoisted_13 = { class: "invoice-detail-table__value" }
const _hoisted_14 = { class: "invoice-detail-table__row" }
const _hoisted_15 = { class: "invoice-detail-table__value" }
const _hoisted_16 = { class: "invoice-detail-table__row" }
const _hoisted_17 = { class: "invoice-detail-table__value" }
const _hoisted_18 = { class: "invoice-detail-table__row" }
const _hoisted_19 = { class: "invoice-detail-table__value" }
const _hoisted_20 = { class: "invoice-detail-table__row" }
const _hoisted_21 = { class: "invoice-detail-table__value" }
const _hoisted_22 = { class: "invoice-detail-table__row" }
const _hoisted_23 = { class: "invoice-detail-table__value" }
const _hoisted_24 = { class: "invoice-detail-table__row" }
const _hoisted_25 = { class: "invoice-detail-table__value" }
const _hoisted_26 = { class: "invoice-detail-table__row" }
const _hoisted_27 = { class: "invoice-detail-table__value" }
const _hoisted_28 = { class: "invoice-detail-table__row" }
const _hoisted_29 = { class: "invoice-detail-table__value" }
const _hoisted_30 = { class: "invoice-detail-table__row" }
const _hoisted_31 = { class: "invoice-detail-table__key nest" }
const _hoisted_32 = { class: "invoice-detail-table__value nest" }
const _hoisted_33 = { class: "invoice-detail-table__row" }
const _hoisted_34 = { class: "invoice-detail-table__key nest" }
const _hoisted_35 = { class: "invoice-detail-table__value nest" }
const _hoisted_36 = { class: "py-4 d-flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[17] || (_cache[17] = _createElementVNode("h2", { class: "mb-2" }, "請求詳細", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.schoolName) + " " + _toDisplayString(_ctx.year) + "年 " + _toDisplayString(_ctx.month) + "月", 1),
      _createVNode(_component_v_spacer),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_select, {
          variant: "outlined",
          density: "compact",
          "hide-details": "",
          items: _ctx.invoiceStatusOptions,
          "item-value": "value",
          "item-title": "label",
          disabled: _ctx.isFetching,
          modelValue: _ctx.invoiceStatus,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.invoiceStatus) = $event)),
          readonly: _ctx.invoiceStatus === 'invoiceSettled'
        }, null, 8, ["items", "disabled", "modelValue", "readonly"])
      ]),
      (_ctx.currentInvoiceStatus !== _ctx.invoiceStatus)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            color: "primary",
            depressed: "",
            class: "mx-1",
            onClick: _ctx.updateStatus
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" 保存 ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_v_data_table, {
      headers: _ctx.headers,
      items: _ctx.tableData,
      expanded: _ctx.expanded,
      "onUpdate:expanded": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.expanded) = $event)),
      "item-value": "childId",
      "single-expand": "",
      loading: _ctx.isFetching
    }, {
      [`item.childId`]: _withCtx(({ item }) => [
        (_ctx.invoiceStatus === 'invoiceSettled')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_v_btn, {
                variant: "flat",
                color: "primary",
                onClick: ($event: any) => (_ctx.openInvoice(item))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { start: "" }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("mdi-tray-arrow-down", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[4] || (_cache[4] = _createTextVNode(" 請求書 ", -1))
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      [`item.collectionMethod`]: _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(_ctx.getPaymentMethodText(item.collectionMethod)), 1)
      ]),
      "expanded-row": _withCtx(({ columns, item }) => [
        _createElementVNode("td", {
          colspan: columns.length,
          class: "px-0"
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "invoice-detail-table__key" }, "月極保育料", -1)),
                _createElementVNode("div", _hoisted_9, _toDisplayString(item.monthlyNurseryFee), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "invoice-detail-table__key" }, "月極保育料 差額", -1)),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_v_text_field, {
                    "hide-details": "",
                    density: "compact",
                    variant: "outlined",
                    type: "number",
                    style: {"font-size":"14px !important"},
                    readonly: _ctx.invoiceStatus === 'invoiceSettled',
                    modelValue: item.monthlyNurseryFeeDiff,
                    "onUpdate:modelValue": ($event: any) => ((item.monthlyNurseryFeeDiff) = $event)
                  }, null, 8, ["readonly", "modelValue", "onUpdate:modelValue"])
                ])
              ]),
              _createVNode(_component_v_divider),
              _createElementVNode("div", _hoisted_12, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "invoice-detail-table__key" }, "月極延長料", -1)),
                _createElementVNode("div", _hoisted_13, _toDisplayString(item.monthlyAdditionalFee), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "invoice-detail-table__key" }, "月極延長料 差額", -1)),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_v_text_field, {
                    "hide-details": "",
                    density: "compact",
                    variant: "outlined",
                    type: "number",
                    style: {"font-size":"14px !important"},
                    readonly: _ctx.invoiceStatus === 'invoiceSettled',
                    modelValue: item.monthlyAdditionalFeeDiff,
                    "onUpdate:modelValue": ($event: any) => ((item.monthlyAdditionalFeeDiff) = $event)
                  }, null, 8, ["readonly", "modelValue", "onUpdate:modelValue"])
                ])
              ]),
              _createVNode(_component_v_divider),
              _createElementVNode("div", _hoisted_16, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "invoice-detail-table__key" }, "一時保育料", -1)),
                _createElementVNode("div", _hoisted_17, _toDisplayString(item.tempNurseryFee), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "invoice-detail-table__key" }, "一時保育料 差額", -1)),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_v_text_field, {
                    "hide-details": "",
                    density: "compact",
                    variant: "outlined",
                    type: "number",
                    style: {"font-size":"14px !important"},
                    readonly: _ctx.invoiceStatus === 'invoiceSettled',
                    modelValue: item.tempNurseryFeeDiff,
                    "onUpdate:modelValue": ($event: any) => ((item.tempNurseryFeeDiff) = $event)
                  }, null, 8, ["readonly", "modelValue", "onUpdate:modelValue"])
                ])
              ]),
              _createVNode(_component_v_divider),
              _createElementVNode("div", _hoisted_20, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "invoice-detail-table__key" }, "スポット延長料", -1)),
                _createElementVNode("div", _hoisted_21, _toDisplayString(item.spotAdditionalFee), 1)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "invoice-detail-table__key" }, "スポット延長料 差額", -1)),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_v_text_field, {
                    "hide-details": "",
                    density: "compact",
                    variant: "outlined",
                    type: "number",
                    style: {"font-size":"14px !important"},
                    readonly: _ctx.invoiceStatus === 'invoiceSettled',
                    modelValue: item.spotAdditionalFeeDiff,
                    "onUpdate:modelValue": ($event: any) => ((item.spotAdditionalFeeDiff) = $event)
                  }, null, 8, ["readonly", "modelValue", "onUpdate:modelValue"])
                ])
              ]),
              _createVNode(_component_v_divider),
              _createElementVNode("div", _hoisted_24, [
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "invoice-detail-table__key" }, "主食・副食費", -1)),
                _createElementVNode("div", _hoisted_25, _toDisplayString(item.foodServiceFee), 1)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "invoice-detail-table__key" }, "主食・副食費 差額", -1)),
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_v_text_field, {
                    "hide-details": "",
                    density: "compact",
                    variant: "outlined",
                    type: "number",
                    style: {"font-size":"14px !important"},
                    readonly: _ctx.invoiceStatus === 'invoiceSettled',
                    modelValue: item.foodServiceFeeDiff,
                    "onUpdate:modelValue": ($event: any) => ((item.foodServiceFeeDiff) = $event)
                  }, null, 8, ["readonly", "modelValue", "onUpdate:modelValue"])
                ])
              ]),
              _createVNode(_component_v_divider),
              _createElementVNode("div", _hoisted_28, [
                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "invoice-detail-table__key" }, "その他", -1)),
                _createElementVNode("div", _hoisted_29, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.extraServices, (extraService, i) => {
                    return (_openBlock(), _createElementBlock("div", { key: i }, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, _toDisplayString(extraService.serviceName), 1),
                        _createElementVNode("div", _hoisted_32, _toDisplayString(extraService.fee), 1)
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, _toDisplayString(extraService.serviceName) + " 差額 ", 1),
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_v_text_field, {
                            "hide-details": "",
                            density: "compact",
                            variant: "outlined",
                            type: "number",
                            style: {"font-size":"14px !important"},
                            readonly: _ctx.invoiceStatus === 'invoiceSettled',
                            modelValue: extraService.adjustmentAmount,
                            "onUpdate:modelValue": ($event: any) => ((extraService.adjustmentAmount) = $event)
                          }, null, 8, ["readonly", "modelValue", "onUpdate:modelValue"])
                        ])
                      ]),
                      (i !== item.extraServices.length - 1)
                        ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createVNode(_component_v_btn, {
                variant: "flat",
                size: "large",
                color: "primary",
                onClick: ($event: any) => (_ctx.saveRecord(item)),
                disabled: _ctx.currentInvoiceStatus !== 'applied',
                loading: _ctx.saveLoading
              }, {
                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                  _createTextVNode(" 保存 ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick", "disabled", "loading"])
            ])
          ])
        ], 8, _hoisted_5)
      ]),
      _: 2
    }, 1032, ["headers", "items", "expanded", "loading"])
  ]))
}